<div class="plan-edit grid-wrapper">
  @if (error) {
    <div class="example-box">
      {{error | json}}
    </div>
  }
  <!-- || editorType.toString() == 'FlowOwners' -->
  <kendo-toolbar>
    <kendo-toolbar-buttongroup [selection]="'multiple'">
      <!-- <ng-container *ngIf="editorType.toString() == 'Flow' || editorType.toString() == 'FlowAdvanced' || editorType.toString() == 'Connection' "> -->
      <kendo-toolbar-button [icon]="'save'" [text]="'Save'" (click)="onSaveClick()"></kendo-toolbar-button>
    <!-- </ng-container> -->
    <kendo-toolbar-button [icon]="'close-circle'" [text]="'Cancel'" (click)="close()"></kendo-toolbar-button>
  </kendo-toolbar-buttongroup>
</kendo-toolbar>
<div style="">
  <ngx-monaco-editor class="monaco-editor" [options]="editorOptions" [(ngModel)]="code" (onInit)="onInit($event)"></ngx-monaco-editor>
</div>
@if (!this.ready) {
  <div class="k-i-loading"></div>
}
</div>